import React, { Component } from 'react';
import { Button, Form, FormGroup, Label, Input, Alert, Card, CardBody, CardTitle } from 'reactstrap';
import { Navigate, useLocation } from 'react-router-dom';

class LoginComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      error: null,
      loading: false,
      redirectToHome: false,
      redirectPath: '/order',
      infoMessage: props.locationState?.message || null
    };
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    const { username, password } = this.state;

    if (!username || !password) {
      this.setState({ error: 'Please enter username and password' });
      return;
    }

    this.setState({ loading: true, error: null });

    try {
      const response = await fetch('api/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password })
      });

      if (response.ok) {
        const data = await response.json();
        // Store user data in localStorage
        localStorage.setItem('user', JSON.stringify(data));
        // Redirect based on user role
        const redirectPath = data.role === 1 ? '/service' : '/order';
        this.setState({ redirectToHome: true, redirectPath });
        // Notify parent component
        if (this.props.onLogin) {
          this.props.onLogin(data);
        }
      } else {
        const error = await response.json();
        this.setState({ error: error.message || 'Login failed', loading: false });
      }
    } catch (error) {
      console.error('Login error:', error);
      this.setState({ error: 'An error occurred during login', loading: false });
    }
  };

  render() {
    const { username, password, error, loading, redirectToHome, redirectPath, infoMessage } = this.state;

    if (redirectToHome) {
      return <Navigate to={redirectPath} />;
    }

    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
        <Card style={{ width: '400px' }} className="coffee-card">
          <CardBody className="p-4">
            <CardTitle tag="h3" className="text-center mb-2" style={{ fontFamily: 'var(--font-display)', color: 'var(--moss-dark)' }}>
              Welcome Back
            </CardTitle>
            <p className="text-center text-muted mb-4" style={{ fontSize: '0.9rem' }}>
              Sign in to order your coffee
            </p>

            {infoMessage && (
              <Alert color="info" toggle={() => this.setState({ infoMessage: null })}>
                {infoMessage}
              </Alert>
            )}

            {error && (
              <Alert color="danger">{error}</Alert>
            )}

            <Form onSubmit={this.handleSubmit}>
              <FormGroup>
                <Label for="username">Username</Label>
                <Input
                  type="text"
                  id="username"
                  value={username}
                  onChange={(e) => this.setState({ username: e.target.value })}
                  disabled={loading}
                  autoFocus
                />
              </FormGroup>

              <FormGroup>
                <Label for="password">Password</Label>
                <Input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => this.setState({ password: e.target.value })}
                  disabled={loading}
                />
              </FormGroup>

              <Button color="primary" type="submit" block disabled={loading}>
                {loading ? 'Logging in...' : 'Login'}
              </Button>
            </Form>

            <div className="text-center mt-4">
              <p className="mb-0" style={{ color: 'var(--warm-gray)' }}>
                New here? <a href="/register" style={{ color: 'var(--moss)' }}>Create an account</a>
              </p>
            </div>
          </CardBody>
        </Card>
      </div>
    );
  }
}

// Wrapper to pass location state to class component
export function Login(props) {
  const location = useLocation();
  return <LoginComponent {...props} locationState={location.state} />;
}

